import AFNavbarBrand from './af-navbar-brand.jsx';

export default AFNavbarBrand;
